import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeControlService } from 'pr1-ui-components';

@Component({
  selector: 'app-offer-group-assets',
  templateUrl: './offer-group-assets.component.html',
  styleUrls: ['./offer-group-assets.component.scss'],
})

export class OfferGroupAssetsComponent implements OnInit {
  offerGroupId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authorizationService: AuthorizeControlService
  ) { }

  ngOnInit(): void {
    this.offerGroupId = this.route.snapshot.params['offerId'];
  }

  cancel(): void {
    this.router.navigate([`../../../`], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }

}
